import { render, staticRenderFns } from "./search-error.vue?vue&type=template&id=b514c068&"
import script from "./search-error.vue?vue&type=script&lang=js&"
export * from "./search-error.vue?vue&type=script&lang=js&"
import style0 from "./search-error.vue?vue&type=style&index=0&id=b514c068&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports